<template>
  <div @click="triggerFileInput">
    <div
      class="bg-blue py-1 px-3 text-white rounded-md w-max max-w-[250px] whitespace-nowrap text-ellipsis overflow-hidden">
      {{ fileName }}
    </div>
    <input type="file" ref="fileInput" @change="handleFileChange" style="display: none"
           accept="image/png, image/jpeg, image/webp" />
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class FileInputComponent extends Vue {
  private fileName = "Выбрать файл";

  private triggerFileInput() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  private handleFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    this.fileName = file?.name || "Выбрать файл";
    this.$emit("fileUpload", file);
  }
}
</script>